module.exports = __webpack_public_path__ + "img/Replace_Icon.400d23cb.svg";